
























































































import Vue, { PropType } from 'vue';
import AppLayer from '@/components/molecules/appLayer/AppLayer.vue';
import AppButton from '@/components/atoms/appButton/AppButton.vue';
import CloseButton from '@/components/atoms/closeButton/CloseButton.vue';
import { Event } from '@/api/interfaces/event/event';
import { EventModalContent } from '@/api/interfaces/content/app/eventModalContent';
import { interpolate } from '@/filters/interpolate';
import { EntryListContentFinalLayer } from '@/api/interfaces/content/common/entryListContent';

export default Vue.extend({
    name: 'EventModal',
    components: { AppLayer, AppButton, CloseButton },
    props: {
        show: { type: Boolean, required: true },
        events: { type: Array as PropType<Event[]>, required: true },
        content: {
            type: Object as PropType<EventModalContent>,
            required: true,
        },
        enumsContent: {
            type: Object as PropType<{
                events: EntryListContentFinalLayer;
            }>,
            required: true,
        },
        applicationStatusItems: {
            type: Object,
            default: null,
        },
        applicationId: { type: String, required: true },
    },
    computed: {
        sortedEvents(): Event[] {
            return this.events;
        },
    },
    methods: {
        getEventRawData(event: Event): string {
            return JSON.stringify(event, null, 2);
        },
        getEventTypeDescription(event: Event): string {
            const eventTypeCased = `${event.eventType[0].toLowerCase()}${event.eventType.slice(
                1,
            )}`;
            const description = this.enumsContent.events[eventTypeCased];

            if (event.eventType === 'ApplicationStatusChanged') {
                const status = event.data.status as string;
                let statusCased = `${status[0].toLowerCase()}${status.slice(
                    1,
                )}`;
                event.data.statusTranslated =
                    this.applicationStatusItems?.[statusCased]?.label || status;
            }

            return description ? interpolate(description, event.data) : '';
        },
    },
});
